import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Options to configure the payment method manager.`}</p>
    <Group summary='Properties' mdxType="Group">
      <Item title='stripePublishableKey' subtitle='string' mdxType="Item">
        <p>{`Stripe Publishable Key, used to interact with Stripe's SDK and collect the bank account details, necessary for the `}<inlineCode parentName="p">{`STRIPE_ACH`}</inlineCode>{` payment method. The Publishable Key can be found in the `}<a parentName="p" {...{
            "href": "https://dashboard.stripe.com/test/apikeys"
          }}>{`Stripe Dashboard API keys`}</a>{`. `}</p>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      